import React from 'react';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const Item = ({item}) => {
    if(!item) return '';
    
    const title = item ? item.title : '';
    const text = item.text ? item.text : '';
    const icon = item.icons ? item.icons : '';
    const url = item.url ? item.url : '';
    const urlTarget = item.url_target ? item.url_target : '';
    const active = item.active ? item.active : '';

    const tagInteraction = (title, url, creative) => {
        TagManagerService.interaction(title, url, creative);
    };

    if(!active) return false;

    return (
        <Link className="small-informative-items" to={url} target={urlTarget} onClick={() => tagInteraction(title, url, 'Calugas Informativas: ' + title)}>
            <i className={'small-informative-icons '+ ("jumbo-icon-" + icon)}></i>
            <div>
                <h1 className='small-informative-title'>{title}</h1>
                <span className='small-informative-text'>{text}</span>
            </div>
        </Link> 
    )
}

export default Item;